class TSHeader extends HTMLElement {
  constructor() {
    super();
    this.searchPopup = document.querySelector("#search-popdown");
    this.searchUnderlay = document.querySelector("[data-search-underlay]");
    this.headerHeight = this.getBoundingClientRect().height;
    this.notification = document.querySelector("#TSNotification");
    this.notificationTriggers = document.querySelectorAll('[data-trigger="notification"]');
    this.searchTrigger = document.querySelector('[data-trigger="search-menu"]');
    this.viewedItemsCookieName = 'viewedItems';
    this.allNotificationItems = [...document.querySelectorAll('.ts-favorites__link')].map(item => item.dataset.id);
    this.allViewedNotificationItems = this.getCookie(this.viewedItemsCookieName) || [];
    this.currentScrollTop = 0;
    this.headerBounds = {};

    this.initSearchClick();
    this.calcHeader();
    this.createObserver();
    window.addEventListener('scroll', this.onScroll.bind(this));

    if (initDrawer) new initDrawer(document.querySelector("#header-menu"));
    
    if (this.notification) this.updateCounter();

    this.notificationTriggers.forEach(notificationTrigger => {
      notificationTrigger.addEventListener("click", () => {
        if (this.notification) {
          this.notification.classList.add("open");
          document.documentElement.style.overflow = "hidden";

          this.allViewedNotificationItems = [...new Set([...this.allViewedNotificationItems, ...this.allNotificationItems])]; 
          this.setCookie(this.viewedItemsCookieName, this.allViewedNotificationItems, 7);
          this.updateCounter();
        }
      })
    })

    if (this.searchTrigger) {
      this.searchTrigger.addEventListener("click", () => {
        const menuToggle = document.querySelector('[data-drawer-toggle="hamburger"]');
        if (menuToggle && !menuToggle.classList.contains("is-open")) {
          menuToggle.click();
          document.querySelector('input[data-predictive-search-input]').focus({ focusVisible: true });
        }
        document.querySelector('input[data-predictive-search-input]').focus({ focusVisible: true });
      })
    }
  }

  calcHeader() {
		const headerObserver = new ResizeObserver(() => {
			this.headerHeight = this.getBoundingClientRect().height;
			document.documentElement.style.setProperty('--ts-header-height', `${this.headerHeight}px`);
		});

		headerObserver.observe(this);
	}

  initSearchClick() {
    document.querySelectorAll("[data-close-popdown]").forEach(closePopupButton => {
      closePopupButton.addEventListener("click", () => {
        this.hidePopdown();
      })
    })

    this.searchUnderlay.addEventListener("click", () => {
      this.hidePopdown();
    })
    
    this.querySelector("[data-popdown-toggle]").addEventListener("click", () => {
      this.showPopdown();
    })
  }

  hidePopdown() {
    this.searchPopup.classList.remove("is-visible");
    this.searchUnderlay.classList.remove("underlay--visible");
    this.searchPopup.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
      bubbles: true
    }));
  }

  showPopdown() {
    this.searchPopup.classList.add("is-visible");
    this.searchPopup.querySelector("input").focus();
    this.searchUnderlay.classList.add("underlay--visible");
    this.searchPopup.dispatchEvent(new CustomEvent('theme:scroll:lock', {
      bubbles: true
    }));
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${JSON.stringify(value)};expires=${date.toUTCString()};path=/`;
  }

  getCookie(name) {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    const cookie = cookies.find(cookie => cookie.startsWith(`${name}=`));
    return cookie ? JSON.parse(cookie.split('=')[1]) : null;
  }

  updateCounter() {
    const unseenItems = this.allNotificationItems.filter(item => !this.allViewedNotificationItems.includes(item));
    
    this.notificationTriggers.forEach(counter => {
      if (unseenItems.length > 0) {
        counter.setAttribute("data-count", unseenItems.length);
      } else {
        counter.removeAttribute("data-count");
      }
    })
  }

  createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this);
	}

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			this.hide();
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			this.show();
		} else if (scrollTop <= this.headerBounds.top) {
			this.reset();
		}

    this.currentScrollTop = scrollTop;
  }

  show() {
    this.classList.add("sticky", "show");
  }

  hide() {
    this.classList.add("sticky");
    this.classList.remove("show");
  }

  reset() {
    this.classList.remove("sticky", "show");
  }
}

customElements.define("ts-header", TSHeader);